export class ReportAddService {
    constructor($resource, ApiService) {
        'ngInject';

        this.$resource = $resource;
        this.apiService = ApiService;
    }

    setReportDetailsdata({title="", uuid="", selectedProgramYearId="", selectedServiceAreaId=""}) {
        const details = {
			title,
			pdf: uuid
		};

        if(selectedProgramYearId && selectedServiceAreaId) {
            details.service_area_id = selectedServiceAreaId;
            details.fiscal_year_id = selectedProgramYearId;
        }

        return details;
	}
}


// WEBPACK FOOTER //
// ./src/app/components/report-add/report-add.service.js